module.exports = __webpack_public_path__ + "img/volume-low-1.a4781685.svg";